import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { AccountRoutingModule } from './account-routing.module';
import { AuthService } from '../auth/services/authentication.service';
import { LogoutCallBackComponent } from './logout/logout-callback.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

@NgModule({
  declarations: [
    LoginComponent,
    AuthCallbackComponent, 
    LogoutCallBackComponent
  ],
  providers: [
    AuthService
  ],
  imports: [
    CommonModule,
    AccountRoutingModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
  ]
})
export class AccountModule { }
